<template>
  <div>
    <el-form :inline="true" :model="queryInfo" class="demo-form-inline">
      <el-form-item label="用户名称">
        <el-input v-model="queryInfo.adminName" clearable @clear="initMethods" @change="current"></el-input>
      </el-form-item>
      <el-form-item label="时间周期">
        <el-date-picker v-model="value" type="daterange" @blur="pickBlur" :picker-options="pickerOptions"
          range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
          @change="changeTime">
        </el-date-picker>
      </el-form-item>
      <el-button type="primary" icon="el-icon-refresh-left" @click="rest">重置</el-button>
    </el-form>
    <el-card>
      <!--  -->
      <!-- table表格区域 -->
      <el-table :data="tableList" border stripe empty-text="暂无数据">
        <el-table-column align="center" label="用户" prop="adminName" width="180">
          <template slot-scope="scope">
            <span>{{ typename(scope.row.adminName) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="登陆IP" prop="ip" width="180"></el-table-column>
        <el-table-column align="center" label="登陆地址" prop="address"></el-table-column>
        <el-table-column align="center" label="登陆系统" prop="os" width="160"></el-table-column>
        <el-table-column align="center" label="创建时间" prop="createTime" width="100px">
          <template slot-scope="scope">
            {{ typename(scope.row.createTime | scope.row.ateFormat) }}
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" width="130px" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="danger" icon="el-icon-delete" @click="removeById(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
const adminId = window.sessionStorage.getItem('adminId');
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {

  },
  data() {
    return {
      value: ['', ''],
      tableList: [],
      total: 0,
      queryInfo: {
        adminName: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        stationId: ''
      },
      pickerOptions: {
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime()
          const start = this.formatDate(obj.minDate, 'start')
          const end = this.formatDate(obj.maxDate, 'end')
          obj.maxDate && (this.value = [start, end])
        },
        disabledDate: time => {
          if (this.pickerMinDate) {
            const oneMonth = 1000 * 3600 * 24 * 31
            const maxTime = this.pickerMinDate + oneMonth
            const mixTime = this.pickerMinDate - oneMonth + 1000 * 3600 * 24
            const tomorrow = new Date(this.formatDate(new Date().getTime() + 1000 * 3600 * 24, 'start'))
            return time.getTime() >= tomorrow || time.getTime() >= maxTime || time.getTime() < mixTime
          }
        }
      },
      pickerMinDate: '',
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.initMethods()
  },
  methods: {
    current() {
      this.queryInfo.page = 1; this.initMethods();
    },
    changeTime(value) {
      this.queryInfo.startTime = !value || value.legth == 0 ? null : value[0];
      this.queryInfo.endTime = !value || value.legth == 0 ? null : value[1];
      if (!value) {
        this.pickerMinDate = '';
      }
      this.current()
    },
    formatDate(datetime, type) {
      const time = new Date(datetime)
      const year = time.getFullYear()
      const month = (time.getMonth() + 1).toString().padStart(2, '0')
      const date = (time.getDate()).toString().padStart(2, '0')
      return type === 'start' ? year + '-' + month + '-' + date + ' ' + '00' + ':' + '00' + ':' + '00' : year + '-' + month + '-' + date + ' ' + '23' + ':' + '59' + ':' + '59'
    },
    getDate() {
      const start = new Date()
      this.value[0] = this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30, 'start')
      this.value[1] = this.formatDate(start.getTime(), 'end')
    },
    pickBlur() {
      this.pickerMinDate = ''
    },
    rest() {
      this.queryInfo = {
        adminName: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
        stationId: ''
      };
      this.value = ['', '']; this.pickerMinDate = '';
      this.initMethods()
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.queryInfo.page = 1;
      this.initMethods()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.initMethods()
    },
    async initMethods() {
      const { data: res } = await this.$http.get('loginLog/getAllAdminLoginLog', { params: this.queryInfo })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.tableList = res.data
      this.total = res.count
    },
    typename(value) {
      return !value || value == '' ? '--' : value
    },
    // 删除日志
    async removeById(row) {
      const confirmResult = await this.$confirm('此操作将永久删除该日志, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      if (!row.id === null || row.id === '') {
        const { data: res } = await this.$http.post('loginLog/delAdminLoginLog/' + this.ids)
        if (res.code !== 0) {
          return this.$message.error('删除日志失败！')
        }
        this.$message.success('删除日志成功！')
        this.initMethods()
        return;
      }
      const { data: res } = await this.$http.post('loginLog/delAdminLoginLog/' + row.id.toString())
      if (res.code !== 0) {
        return this.$message.error('删除日志失败！')
      }
      this.$message.success('删除日志成功！')
      this.initMethods()

    }
  }
};
</script>
<style lang='' scoped>
</style>